import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import axios from 'axios';

import {
  I18n,
  DataBlocks,
  Preloader,
  Link,
  Status,
  Button,
} from 'components';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default class IPoE extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    axios.get('/api/profile/homeinternet/ipoe/')
      .then(({ data }) => this.setState(data))
      .catch((error) => error);
  }

  updateStatus = () => {
    this.setState({ isUpdating: true });
    axios.get('/api/profile/homeinternet/ipoe/')
      .then(({ data }) => this.setState({
        isUpdated: true,
        isUpdating: false,
        ...data,
      }))
      .catch((error) => error);
  }

  toggleDisconnectDialog = () => {
    this.setState((prevState) => ({
      isDisconnectDialogVisible: !prevState.isDisconnectDialogVisible,
    }));
  }

  disconnect = () => {
    this.setState({
      isDisconnecting: true,
      isDisconnectDialogVisible: false,
    });

    axios.post('/api/profile/homeinternet/delipoeauth/')
      .then(({ data }) => this.setState({
        isDisconnected: data.isSuccess,
        isDisconnecting: false,
      }))
      .catch((error) => error);
  }

  render() {
    const {
      isPromoted,
      isBeelineNetwork,
      isAvailable,
      realEquipment,
      landingUrl,
      captiveUrl,
      isUpdating,
      isUpdated,
      isDisconnectDialogVisible,
      isDisconnecting,
      isDisconnected,
    } = this.state;

    if (!isPromoted || !isAvailable) return null;

    if (!realEquipment && isBeelineNetwork) {
      return (
        <DataBlocks.Block className={['attention', cx('component')]}>
          <I18n path="ipoe.isAvailable" />

          <div className={cx('links')}>
            <Link className={cx('link')} href={landingUrl} target="_blank">
              <I18n path="ipoe.moreAbout" />
            </Link>
            <Link className={cx('link')} href={captiveUrl} target="_blank">
              <I18n path="ipoe.connect" />
            </Link>
          </div>

          <div className={cx('links')}>
            <I18n path="ipoe.isConnected" />
            {' '}
            <Link className={cx('link')} onClick={this.updateStatus}>
              <I18n path="ipoe.updateStatus" />
            </Link>
          </div>

          {isUpdating && (
            <Preloader
              className={cx('preloader')}
              size="40"
            />
          )}

          {!isUpdating && isUpdated && (
            <Status className={['error', cx('status')]} emoji="statusFail">
              <I18n path="ipoe.updateError" />
            </Status>
          )}
        </DataBlocks.Block>
      );
    }

    if (realEquipment && isBeelineNetwork) {
      return (
        <DataBlocks.Block
          title={<I18n path="ipoe.isActive" />}
          className="attention"
          info={!isDisconnectDialogVisible && !isDisconnecting && !isDisconnected && (
            <Link className={cx('link')} onClick={this.toggleDisconnectDialog}>
              <I18n path="ipoe.disconnect" />
            </Link>
          )}
        >
          {isDisconnectDialogVisible && (
            <>
              <I18n path="ipoe.disconnectConfirmation" />

              <div className={cx('links')}>
                <Button
                  className={['default', cx('button')]}
                  onClick={this.disconnect}
                >
                  <I18n path="ipoe.disconnect" />
                </Button>
                <Link
                  className={cx('link')}
                  onClick={this.toggleDisconnectDialog}
                >
                  <I18n path="common.cancel" />
                </Link>
              </div>
            </>
          )}

          {isDisconnecting && (
            <Preloader
              className={cx('preloader')}
              size="40"
            />
          )}

          {isDisconnected && (
            <I18n path="ipoe.isDisconnected" />
          )}
        </DataBlocks.Block>
      );
    }

    if (realEquipment && !isBeelineNetwork) {
      return (
        <DataBlocks.Block className={['attention', cx('component')]}>
          <I18n path="ipoe.notBeelineNetwork" />
        </DataBlocks.Block>
      );
    }

    return null;
  }
}
